import { Box, Text } from '@chakra-ui/react';

interface PasswordValidationProps {
  password: string;
  errors: string[];
}

export const PasswordValidation = ({
  password,
  errors,
}: PasswordValidationProps) => {
  if (password.length === 0 || errors.length === 0) {
    return null;
  }

  return (
    <Box mt="2" px="1">
      {errors.map((error, index) => (
        <Text key={index} fontSize="xs" color="volyx.error" fontFamily="body" mb="0.5" lineHeight="tight">
          • {error}
        </Text>
      ))}
    </Box>
  );
};
